import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { API } from "@/lib/format";
import { useKiosk } from "./KioskContext";

export const KioskSettings = ({ open, onOpenChange }) => {
  const { kioskId, setKioskId, data } = useKiosk();
  const [kiosks, setKiosks] = useState([]);
  useEffect(() => {
    if (open) fetch(`${API}/kiosk/kiosks`).then((r) => r.json()).then(setKiosks).catch(() => {});
  }, [open]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-[28px]" data-testid="kiosk-settings-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Kiosk setup</DialogTitle>
          <DialogDescription>
            This screen is {data?.kiosk?.name} ({kioskId}) at {data?.showroom?.name}. Leads and proof-of-play are tagged with this kiosk.
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2 max-h-[320px] overflow-auto">
          {kiosks.map((k) => (
            <button key={k.id} data-testid={`kiosk-pick-${k.id}`} onClick={() => { setKioskId(k.id); onOpenChange(false); }}
              className={`min-h-[52px] rounded-2xl px-4 text-left text-sm ${k.id === kioskId ? "bg-[#0B8577] text-white" : "bg-[#F5F5F7]"}`}>
              <div className="font-semibold">{k.id}</div>
              <div className="opacity-75 truncate">{k.name}</div>
            </button>
          ))}
        </div>
        <Link to="/admin" data-testid="kiosk-open-admin" className="btn-pill btn-ghost w-full">Open Panelo admin</Link>
      </DialogContent>
    </Dialog>
  );
};
